module.exports = __webpack_public_path__ + "img/aoyu.70af2668.jpg";